/**
 * @generated SignedSource<<fbf74e2f8e27c516d151a609330bdb39>>
 * @relayHash e1813bbb41046aec3efb89526f4d8a64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ccedcc4a267f2d235ba44126280a5546c1b121ea257a05a0cbaf71c718bd2bf9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { OrganizationDetailsOrganizationDetailsPageQuery } from './OrganizationDetailsOrganizationDetailsPageQuery.graphql';

import isAssetsFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerContextRelayprovider';
import isAssetsFastFollowEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerCtxFastFollowsRelayprovider';

const node: PreloadableConcreteRequest<OrganizationDetailsOrganizationDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ccedcc4a267f2d235ba44126280a5546c1b121ea257a05a0cbaf71c718bd2bf9",
    "metadata": {},
    "name": "OrganizationDetailsOrganizationDetailsPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerContextRelayprovidertsx": isAssetsFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerCtxFastFollowsRelayprovidertsx": isAssetsFastFollowEnabled_provider
    }
  }
};

export default node;
